<template>
  <widgetWrapper
    :id="configItem.chartId"
    :title="chartAttr.title"
    :subTitle="chartAttr.subtitle"
    :addtxt="chartAttr.addtxt"
    :info="chartAttr.info"
    :empty="empty"
    :loading="loadingbar"
    :projectName="chartAttr.projectName"
    @ctrl="ctrlClick"
    class="custom3 status-metric-widget"
    style="position: relative"
    :style="{
      background: threshold ? '#fb4d58' : '',
      outline: isSettingMode ? '1px solid #ccc' : '',
      borderRadius: isSettingMode && 'unset',
      width: isSettingMode
    }"
  >
    <div class="text" :class="'h' + (configItem.chartAttr.h == 1 ? 1 : 2)">
      <div style="display: flex">
        <div v-lego-tooltip="tooltipContents">
          {{ item ? item.value : '' }}
        </div>
        <div>
          <span style="font-size: 25px">{{ item && item.unit ? item.unit : '' }}</span>
          <span style="font-size: 14px; margin-left: 5px">{{ item ? item.metricUnit : '' }}</span>
          <span style="font-size: 14px; margin-left: 5px" v-if="unitType == 'NUM'">{{
            metricUnit
          }}</span>
        </div>
      </div>
    </div>
  </widgetWrapper>
</template>
<script>
import widgetWrapper from '@/components/scpm/widgets/common/widgetWrapperScpm';
import widgetMixin from './widgetMixin';
import { getWidgetData } from '../serviceApi';
import i18nMixin from '../../../mixins/i18n.mixin';

export default {
  name: 'StatusMetricWidget',
  components: { widgetWrapper },
  mixins: [widgetMixin, i18nMixin],
  data() {
    return {
      item: {}, // 현황 지표 데이타
      tooltipContents: '', // tooltip html contenst
      tempValue: '', // 현황 지표 value (단위 환산하지 않은 데이타)
      unitType: '',
      metricUnit: ''
    };
  },
  computed: {
    // 위험도 여부
    threshold() {
      if (!this.$util.isEmpty(this.tempValue)) {
        const options = this.configItem.chartAttr.widget.options;
        if (options.thresholdValue && options.comparisonOperator) {
          if (options.comparisonOperator === 'GE') {
            return Number(parseFloat(this.item.value).toFixed(2)) >= parseFloat(options.thresholdValue);
          } else if (options.comparisonOperator === 'LE') {
            return Number(parseFloat(this.item.value).toFixed(2)) <= parseFloat(options.thresholdValue);
          }
        }
      }
      return false;
    },
    empty() {
      return this.$util.isEmpty(this.item) || !this.isWidgetAuth;
    }
  },
  methods: {
    /** API Request */
    getData() {
      //console.log('StatusMetricWidget', 'getData this.configItem = ', this.configItem);
      let options = this.configItem.chartAttr.widget.options;
      // tooltip 생성
      this.createTooltipContents(options);
      let productResourceInfosConsole = this.getProductResourceInfosConsoleParams(options);

      let objectType = '';
      if (
        options.objectType &&
        !this.notObjectItems[options.resourceType].includes(options.objectType)
      ) {
        objectType = options.objectType;
      }
      let body = {
        metricKey: options.metricKey,
        objectType: objectType,
        productResourceInfosConsole: productResourceInfosConsole,
        targetsMethod: options.targetsMethod, //통계 타입 (avg, min, max) RAW method는 우선 보류 220120_SCP-E_Monitoring_Product_API_Spec
        decimalPotint: 4, //소수점(더 작은 값이 나올때만 유의미함) 220120_SCP-E_Monitoring_Product_API_Spec
        valueCalculationSection: 120, //average 평균 낼 구간, 현재 120sec 디폴트 220120_SCP-E_Monitoring_Product_API_Spec
        valueMethod: 'last' //값 통계 유형 (es단에 avg,min,max 있으나 현재 last만 씀) 220120_SCP-E_Monitoring_Product_API_Spec
      };

      if (options.isK8sObjectType && !options.disableIndividualItem) {
        body.productSubName = options.objectItems.map((item) => item.key || item.value);
        body.productSubType = objectType;

        if (options.objects && options.objects.length) {
          body.objectType = options.objects[0].objectType;
        }
      }

      let header = Object.assign({ 'X-ResourceType': options.resourceType }, this.header);
      getWidgetData('post', this.configItem.chartAttr.widget.api, body, header).then((data) => {
        // this.configItem.chartAttr.w = 'max-content';

        if (data instanceof Error) {
          this.item = null;
          return;
        }

        this.metricUnit = data.contents[0].metricUnit;
        this.unitType = this.$util.getUnitType(this.metricUnit);
        this.tempValue = data.contents[0].value;
        let fixUnit = this.metricUnit === 'MB' ? 'MB' : '';

        let tmp;
        if (this.unitType === 'FILE') {
          tmp = this.$util.formatFileUnit(this.tempValue, this.metricUnit, 2, fixUnit, true);
        } else if (this.unitType === 'TIME') {
          tmp = this.$util.formatTimes(this.tempValue, this.metricUnit, 2);
        } else {
          tmp = this.$util.formatNumber(this.tempValue, 2);
        }

        this.item = {
          value: this.$filters.comma(tmp.value),
          metricUnit: tmp.unit
        };
      });
    },

    /** 툴팁 정보 */
    createTooltipContents(options) {
      let _tooltipContents =
        this.$util.capitalize(this.t('label.monitoring')) + ' ' + this.t('label.target');
      options.products.forEach((item) => {
        _tooltipContents += '\n - ' + item.text;
      });
      _tooltipContents +=
        '\n\n' + this.$util.capitalize(this.t('label.performance')) + ' ' + this.t('label.item');
      _tooltipContents += '\n - ' + options.metricName;

      _tooltipContents += '\n\n' + this.$util.capitalize(this.t('label.statistics1'));
      _tooltipContents += '\n - ' + options.targetsMethod;

      this.tooltipContents = _tooltipContents;
    }
  }
};
</script>
<style lang="scss" scoped>
.text {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 4px 0 0;
  font-family: $lego__font-family;
  font-size: 25px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 0.57;
  letter-spacing: normal;
  text-align: right;
  color: var(--dark);
  cursor: default;
}
.h1 {
  height: 100%;
}
.h2 {
  height: 100%;
}
.status-metric-widget {
  overflow: visible !important;
}
</style>
